import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Tag, Popover, Button, Row, Col} from 'antd'
import { PhoneOutlined } from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import FormModal from '../../manualOutboundCall/components/FormModal'
import history from '../../../routes/history'

@inject('marketingResourcePoolStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    phoneObj: null
  }
  componentDidMount() {
    const {marketingResourcePoolStore} = this.props
    marketingResourcePoolStore.onClearSelectedRowKeys([],[])
  }
  handlePageChange = (page, pageSize) => {
    const {marketingResourcePoolStore} = this.props
    marketingResourcePoolStore.onChangePageNumDetailsAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleSelect = (val) => {
    const {marketingResourcePoolStore} = this.props
    const {detailsList} = marketingResourcePoolStore
    const ids = toJS(detailsList).map(a=> {return a?.id})
    val ? marketingResourcePoolStore.onClearSelectedRowKeys(ids,toJS(detailsList)) : marketingResourcePoolStore.onClearSelectedRowKeys([],[])
    marketingResourcePoolStore.onChangeIsAll(val)
  }
  handleCall = (phoneObj) => {
    this.setState({
      addModalVisible: true,
      phoneObj
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false,
      phoneObj: null
    })
  }
  maskPhone = (phone) => {
    if (!phone || phone.length !== 11) return phone;
    return phone.slice(0, 2) + '*'.repeat(7) + phone.slice(-2);
  }

  maskEmail = (email) => {
    if (!email || !email.includes('@')) return email;
    const [prefix, domain] = email.split('@');
    if (prefix.length <= 2) return prefix + '***@' + domain;
    return prefix[0] + '*'.repeat(prefix.length - 2) + prefix[prefix.length - 1] + '@' + domain;
  }

  render() {
    const {marketingResourcePoolStore, record, t} = this.props
    const {pageNoDetails, pageSizeDetails, itemCountDetails, detailsList, headerList, detailsObj, groupList, selectedRowKeys, selectedRows, isAll} = marketingResourcePoolStore
    const pagination = getPaginationConfig(pageNoDetails, pageSizeDetails, itemCountDetails, this.handlePageChange)
    const rowSelection = {
      selectedRowKeys,
      onSelectAll(selected, selectedRows) {
        if(selected) {
          if(selectedRows.length === itemCountDetails) marketingResourcePoolStore.onChangeIsAll(true)
          marketingResourcePoolStore.onChangeSelectedRowKeys(selectedRows?.map(a=>{return a?.id}),selectedRows)
        } else {
          marketingResourcePoolStore.onChangeIsAll(false)
          marketingResourcePoolStore.onCutSelectedRowKeys(detailsList?.map(a=>{return a?.id}),selectedRows)
        }
      },
      onSelect(record, selected, selectedRows, nativeEvent){
        if(selected) {
          if(selectedRows.length === itemCountDetails) {
            marketingResourcePoolStore.onChangeIsAll(true)
          }
          marketingResourcePoolStore.onChangeSelectedRowKeys(record?.id,selectedRows)
        } else {
          marketingResourcePoolStore.onChangeIsAll(false)
          marketingResourcePoolStore.onCutSelectedRowKeys(record?.id,selectedRows)
        }
      },
      // onChange: this.onSelectChange
    };
    const TagsList = (tags) => {
      const maxCount = 2; // 最多显示的 Tag 数量
      const remainingCount = tags?.length - maxCount; // 剩余的 Tag 数量
    
      // 如果 Tag 数量超过 maxCount，则截取前 maxCount 个，剩余的用 Tooltip 显示
      const visibleTags = tags?.slice(0, maxCount);
      const content = tags?.map((tag, index) => (
        <Tag color="blue" key={index}>{tag}</Tag>
      ))
      return (
        <div>
          {/* 显示可见的 Tag */}
          {visibleTags?.map((tag, index) => (
            <Tag color="blue" key={index}>{tag}</Tag>
          ))}
    
          {/* 如果有多余的 Tag，显示剩余数量，并用 Tooltip 展示所有隐藏的 Tag */}
          {remainingCount > 0 && (
          <Popover content={content}>
              <Tag color="blue">+{remainingCount}</Tag>
          </Popover>
          )}
        </div>
      );
    };
    return (
      <>
        <Row>
          <Col span={12}>
            <Button onClick={()=>this.handleSelect(!isAll)} type="primary">{isAll ? '取消全选' : '全选'}</Button>
          </Col>
          <Col span={12}>
          <div className='emulator-balance'>当前已选中： <span>{isAll ? itemCountDetails : selectedRowKeys.length}</span> 人</div>
          </Col>
        </Row>
        <Table className="searchResult" dataSource={toJS(detailsList)} pagination={pagination} scroll={{ x: 'max-content' }} rowKey='id' rowClassName={this.getRowClassName} style={{marginTop: 10, paddingTop: 0}} rowSelection={rowSelection}>
          {
            headerList?.map((a, i) =>
              <Table.Column
                title={a?.name}
                dataIndex={a?.name}
                key={i}
                render={(text, record) =>
                  a?.name === '手机号码'
                    ? this.maskPhone(text)
                    : a?.name === '邮件地址'
                      ? this.maskEmail(text)
                      : detailsObj?.conditions?.find(c => c?.name === a?.name)?.configType === '3'
                        ? TagsList(text?.split('、'))
                        : text
                }
              />)
          }
          {record?.marketingType?.includes('4') && <Table.Column width={200} title={t(`general.action`)} dataIndex="Action" key="Action" 
          render={(text, row, index) => (<>
            <Button type="link" onClick={() => this.handleCall({...record, ...row})} icon={<PhoneOutlined />} title={t(`general.view`)} />
          </>)}>
          </Table.Column>}
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          phoneObj={this.state.phoneObj}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
